import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

import { TOOLS_OPTIONS_OBJECT } from '../../configs/tools.configs';

interface modelSurfaceState {
  toolSelected: string;
}

const initialState: modelSurfaceState = {
  toolSelected: TOOLS_OPTIONS_OBJECT.map.label,
};

export const admin2ToolsSlice = createSlice({
  name: 'admin2ToolsSlice',
  initialState,
  reducers: {
    setToolSelected: (state, action: PayloadAction<string>) => {
      state.toolSelected = action.payload;
    },
  },
});

export const { setToolSelected } = admin2ToolsSlice.actions;

export const $toolSelected = (state: RootState) => state.admin2ToolsSlice.toolSelected;

export default admin2ToolsSlice.reducer;
